<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Substeps
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

const rules = {
  umsokn: {
    confirm: { sameAs: sameAs(true) }
  }
}

const v$ = useVuelidate(rules, { umsokn })

const expanded = ref([0]) 

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('sereignar_umsokn_step4_header') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <p>{{ t('sereignar_umsokn_step4_header2') }}</p>
      </v-col>
    </v-row>

    <!-- Summary expansion -->
    <v-row>
      <v-col>
        <v-expansion-panels v-model="expanded">
          <v-expansion-panel value="0">
            <v-expansion-panel-title>
              {{ t('sereignar_umsokn_step4_information') }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <div class="mt-6">
                <Umsaekjandi :disable="true" />
              </div>
              <div class="mt-6">
                <Step2 :disable="true" />
              </div>
              <div class="mt-6">
                <Step3 :disable="true" />
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <!-- Terms link -->
    <v-row>
      <v-col>
        <p>
          <a
            target="_blank"
            :href="t('sereignar_umsokn_step4_skilmalar_hlekkur')"
          >
            {{ t('sereignar_umsokn_step4_header3') }}
          </a>
        </p>
      </v-col>
    </v-row>

    <!-- Confirmation -->
    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.confirm"
          :readonly="props.disable"
          :label="t('sereignar_umsokn_step4_confirm')"
          :error="v$.umsokn.confirm.$error"
          :error-messages="v$.umsokn.confirm.$error ? [t('sereignar_umsokn_step4_confirm_error')] : []"
        />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
p {
  color: #194458;
  font-size: 22px;
  line-height: 35px;
}
</style>
